import styled from 'styled-components';

export const FormContainer = styled.div`
  .field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;

    label {
      margin-bottom: 0.5rem;
    }
  }
`;
